import { usePrices } from '../hooks/support'
import { useUser } from '../hooks/user'
import { Benefits } from './Benefits'
import { formatPrice } from './formatPrice'
import { Logo } from './Logo'
import { OfferNote } from './OfferNote'
import css from '../style.module.scss'
import { t } from '../hooks/translations'

export const Sidebar = function Sidebar() {
  const { offer } = useUser()
  const { currency, annually } = usePrices()

  return (
    <div className={css['show-for-tablet']}>
      <Logo style={{ marginBottom: 16 }} />
      <OfferNote />
      <Benefits />
      {offer === 'yearly' && (
        <p>
          {t('sum_billed_yearly', {
            sum1: formatPrice({ prefix: currency.prefix, unitAmount: annually.unit_amount / 100 }),
            sum2: formatPrice({
              prefix: currency.prefix,
              unitAmount: annually.unit_amount / 100 / 12
            })
          })}
        </p>
      )}
    </div>
  )
}
